import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/premium-stores/plan-management')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
